const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
const TIMEOUT_SEC = 10;
const RES_PER_PAGE = 10;
const KEY = '22f79fd2-cd2e-45ee-b5e5-adeed23838ea';
const MODAL_CLOSE_SEC = 1.5;

export { API_URL, TIMEOUT_SEC, RES_PER_PAGE, KEY, MODAL_CLOSE_SEC };
